import {
    button,
    checkbox,
    dataTable,
    datePicker,
    dynamicDropdown,
    formField,
    globalStyle,
    link,
    modal,
    overflowMenu,
    pagination,
    radio,
    tag,
    tooltip,
    typography,
} from "@iewcasia/Utilities/styleguide";
import { colorPalette, colorStrings } from "@iewcasia/Utilities/variables";
import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

const setPreStyles = () => {
    // Add some post styleguide customizations. These cannot be overridden by the style guid.
    setPreStyleGuideTheme({
        button,
        checkbox,
        colors: colorPalette,
        dataTable,
        datePicker,
        dynamicDropdown,
        formField,
        globalStyle,
        header: {
            backgroundColor: colorStrings.primaryMain,
            isDropShadow: true,
            dropShadowStyle: "dark",
        },
        link,
        modal,
        overflowMenu,
        pagination,
        radio,
        tag,
        tooltip,
        typography,
    });
};

export default setPreStyles;
